var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMongodb = function SvgMongodb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f042927a-a948-4826-984e-f712867984cd",
    "data-name": "Layer 1",
    viewBox: "0 0 18.4 40.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1,5.2l1.1,2,.9,1a34.7,34.7,0,0,1,2.5,2.9,23.6,23.6,0,0,1,4,8.1,24.4,24.4,0,0,1,.9,5.4,19.7,19.7,0,0,1-5.7,14.2,10.6,10.6,0,0,1-2,1.7c-.4,0-.5-.3-.7-.5a5.2,5.2,0,0,1-.6-1.6,6.9,6.9,0,0,1-.1-2V36c-.1,0-.4-30.7-.3-30.8Z",
    transform: "translate(-7.1 -5)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,5.1H16a1.6,1.6,0,0,1-.4,1.2,4.3,4.3,0,0,1-.9,1,20.3,20.3,0,0,0-4.8,6.1,23.4,23.4,0,0,0-2.8,10,33.4,33.4,0,0,0,.8,7,21.4,21.4,0,0,0,5.6,8.8l2,1.7c.2,0,.2-.2.3-.3a2.9,2.9,0,0,1,.2-.9c.2-1.1.3-2.2.4-3.3L16.2,5.1Z",
    transform: "translate(-7.1 -5)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,41.9a4.2,4.2,0,0,1,.6-1.4,1,1,0,0,1-.6-.5,3,3,0,0,1-.4-.8,13.5,13.5,0,0,1-.4-2.8v-.6a2.9,2.9,0,0,0-.2.9,13.6,13.6,0,0,1-.4,3,2.7,2.7,0,0,1-.3,1.2v.2a13.6,13.6,0,0,1,.6,3.6v.4c0,.5,0,.4.4.6l.6.2c.1,0,.1-.1.1-.2V42.9a3.4,3.4,0,0,1,0-1Z",
    transform: "translate(-7.1 -5)",
    style: {
      fill: "#183149"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMongodb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mongodb.29103106.svg";
export { ForwardRef as ReactComponent };